// extracted by mini-css-extract-plugin
export default {"home":"homescreen_home__ytGvC","lightWrapper":"homescreen_lightWrapper__MDCNd"};